






















import { Component, Mixins, Ref, Vue } from "vue-property-decorator";
import Main from "@/components/app/Main.vue";
import Login from "@/components/app/Login.vue";
import DoubleLoginArea from "@/components/app/DoubleLoginArea.vue";
import ChangePassword from "@/components/app/ChangePassword.vue";
import Cookies from "js-cookie";
import AxiosMixin from "@/mixins/axiosMixin";
import { namespace, Mutation, State } from "vuex-class";
import * as user from "@/store/modules/user/types";
import * as root from "@/store/types";
import UserMixin from "./mixins/userMixin";
import { Route } from "vue-router";
import AppConfirm from "#/components/AppAlertConfirm.vue";
import { signInWithFirebaseCustomToken } from "#/mixins/firebase";

const User = namespace(user.name);

window.axios = require("axios");

window.base_url = process.env.VUE_APP_BACKEND_URL;
if (!window.base_url) {
  window.base_url = "http://localhost:8083";
}

window.ibow_url = process.env.VUE_APP_IBOW_FRONTEND_URL;
if (!window.ibow_url) {
  window.ibow_url = "http://localhost:9000";
}

window.ibow_auth_url = process.env.VUE_APP_FRONTEND_AUTH_URL;
if (!window.ibow_auth_url) {
  window.ibow_auth_url = "http://localhost:9200";
}

window.portal_url = process.env.VUE_APP_PORTAL_FRONTEND_URL;
if (!window.portal_url) {
  window.portal_url = "https://carelogood.launchibow2.jp";
}

window.kaedoki_url = process.env.VUE_APP_KAEDOKI_FRONTEND_URL;
if (!window.kaedoki_url) {
  window.kaedoki_url = "https://jobsearch.launchibow.jp";
}

@Component({
  components: {
    Main,
    Login,
    DoubleLoginArea,
    ChangePassword,
    AppConfirm,
  },
})
export default class App extends Mixins(AxiosMixin, UserMixin) {
  protected isToken = false; //トークン認証済みかどうか
  protected isDisp = false; //画面描画するかどうか

  @User.Mutation(user.SET_USER) setUser!: Function;

  @Mutation(root.SET_IS_REGISTERD_AUTH_NAVIGATION)
  setIsRegisterdAuthNavigation!: Function;

  @State is_registerd_auth_navigation!: boolean;

  @Ref("app_confirm") private readonly appConfirm!: AppConfirm;
  /** 2段階認証 */
  private isDoubleLogin = false;
  /** パスワード変更要否 */
  private needPasswordChange = false;
  /** Firebase カスタムトークン認証の実行中かどうか */
  private firebaseLoading = false;

  created() {
    //トークン
    const token = Cookies.get("admin-token");
    if (token) {
      window.token = token;
      const needPwChange = Cookies.get("admin-need-pw-change");
      if (needPwChange === "1") {
        this.needPasswordChange = true;
      }
    }

    //リフレッシュトークン
    let canGetUser = false;
    const reftoken = Cookies.get("admin-reftoken");
    if (reftoken) {
      window.reftoken = reftoken;
      canGetUser = true;
    }

    //名前
    const name = Cookies.get("admin-name");
    if (name) {
      window.name = name;
    }

    //取得後の権限取得
    if (canGetUser) {
      this.postJsonCheck(
        window.base_url + "/api/admin-user/get",
        {},
        async (res) => {
          this.setUser(res.data);
          this.isToken = true;

          // Firebase サインイン完了を待ってから画面を描画する（Firestore 利用画面が認証前に初期化されるのを防ぐ）
          // JWT リフレッシュを経由させるため postJsonBackground を Promise でラップして使う
          this.firebaseLoading = true;
          await signInWithFirebaseCustomToken(
            () =>
              new Promise<string>((resolve, reject) => {
                const timeoutId = setTimeout(
                  () => reject(new Error("firebase-custom-token timeout")),
                  10000
                );
                this.postJsonBackground(
                  window.base_url + "/api/admin/firebase-custom-token",
                  {},
                  (res: { data: { firebase_token: string } }) => {
                    clearTimeout(timeoutId);
                    resolve(res.data.firebase_token);
                  },
                  () => {
                    clearTimeout(timeoutId);
                    reject(new Error("firebase-custom-token fetch failed"));
                  }
                );
              })
          );

          this.isDisp = true;
          this.firebaseLoading = false;

          // ナビゲーションガード登録前の権限チェック
          if (!this.hasRoutingAuth(this.$router.currentRoute)) {
            this.$router.push({ path: "/" });
          }

          // ナビゲーションガード登録
          if (!this.is_registerd_auth_navigation) {
            this.setIsRegisterdAuthNavigation(true);
            this.$router.beforeEach((to, from, next) => {
              this.hasRoutingAuth(to) ? next() : next(false);
            });
          }
        }
      );
    } else {
      this.isDisp = true;
    }
  }

  mounted() {
    // this使えないので、参照を保持
    const dialog = this.appConfirm;

    // アラートダイアログ呼び出し用インスタンスプロパティ作成
    Vue.prototype.$openAlert = async function (text: string): Promise<boolean> {
      dialog.isConfirm = false;
      const res = await dialog.open(text);
      return res;
    };
    // 確認ダイアログ呼び出し用インスタンスプロパティ作成
    Vue.prototype.$openConfirm = async function (
      text: string,
      okLabel = "OK",
      cancelLabel = "キャンセル"
    ): Promise<boolean> {
      dialog.isConfirm = true;
      const res = await dialog.open(text, okLabel, cancelLabel);
      return res;
    };
  }
  // 認証が成功した後の処理
  private async logined(needPwChange?: boolean) {
    this.isDoubleLogin = false;
    this.needPasswordChange = !!needPwChange;

    if (this.needPasswordChange) {
      this.isToken = true;
      Cookies.set("admin-need-pw-change", "1");
      return;
    }

    // Firebase サインイン完了を待ってから画面を描画する（Firestore 利用画面が認証前に初期化されるのを防ぐ）
    // JWT リフレッシュを経由させるため postJsonBackground を Promise でラップして使う
    this.firebaseLoading = true;
    await signInWithFirebaseCustomToken(
      () =>
        new Promise<string>((resolve, reject) => {
          this.postJsonBackground(
            window.base_url + "/api/admin/firebase-custom-token",
            {},
            (res: { data: { firebase_token: string } }) => {
              resolve(res.data.firebase_token);
            },
            () => { reject(new Error("firebase-custom-token fetch failed")); }
          );
        })
    );

    this.isToken = true;
    this.firebaseLoading = false;

    // ナビゲーションガード登録前の権限チェック
    if (!this.hasRoutingAuth(this.$router.currentRoute)) {
      this.$router.push({ path: "/" });
    }

    // ナビゲーションガード登録
    if (!this.is_registerd_auth_navigation) {
      this.setIsRegisterdAuthNavigation(true);
      this.$router.beforeEach((to, from, next) => {
        this.hasRoutingAuth(to) ? next() : next(false);
      });
    }
  }

  // パスワード変更完了後の処理
  private async onPasswordChanged() {
    Cookies.remove("admin-need-pw-change");

    // Firebase サインイン完了を待ってから画面を描画する（Firestore 利用画面が認証前に初期化されるのを防ぐ）
    // JWT リフレッシュを経由させるため postJsonBackground を Promise でラップして使う
    await signInWithFirebaseCustomToken(
      () =>
        new Promise<string>((resolve, reject) => {
          this.postJsonBackground(
            window.base_url + "/api/admin/firebase-custom-token",
            {},
            (res: { data: { firebase_token: string } }) => {
              resolve(res.data.firebase_token);
            },
            () => { reject(new Error("firebase-custom-token fetch failed")); }
          );
        })
    );

    this.needPasswordChange = false;

    // ナビゲーションガード登録前の権限チェック
    if (!this.hasRoutingAuth(this.$router.currentRoute)) {
      this.$router.push({ path: "/" });
    }

    // ナビゲーションガード登録
    if (!this.is_registerd_auth_navigation) {
      this.setIsRegisterdAuthNavigation(true);
      this.$router.beforeEach((to, from, next) => {
        this.hasRoutingAuth(to) ? next() : next(false);
      });
    }
  }

  /** 指定ルートに移動できるか判定 */
  private hasRoutingAuth(to: Route): boolean {
    // "/"への移動は権限なしで可能
    if (to?.meta?.authName == "/") {
      return true;
    }

    // ログインユーザが存在しない場合はNG
    if (!this.User) {
      return false;
    }

    // 権限取得
    const auth = this.User.admin_auth.admin_auth_functions.find(
      (adminAuthFunction) => {
        return adminAuthFunction.function.path == to?.meta?.authName;
      }
    );

    // 権限情報が存在しない場合はNG
    if (!auth) {
      return false;
    }

    // 閲覧権限がない場合はNG
    if (!auth.is_reading) {
      return false;
    }

    // 編集権限がない場合は編集系画面に行けない
    if (auth.is_editing == 0 && to?.meta?.is_edit_page == true) {
      return false;
    }

    return true;
  }
}
